import React, {useEffect} from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import {Input, Typography} from "@material-ui/core";
import {useState} from "react";
import {useRef} from "react";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import InfoIconComponent from "./InfoIcon";

export function CreateTacticTreeItem({
                                         classes,
                                         label,
                                         nodeId,
                                         tacticEnabledHook,
                                         tacticComponent,
                                         docs,
                                     }) {
    const [tacticEnabled, setTacticEnabled] = tacticEnabledHook;

    return (
        /*<Grid item container>
                <Grid item xs={2}>
                    <IconButton size="small" style={{width: 1, height: 1,}} color="primary">
                        <InfoIcon fontSize="small"/>
                    </IconButton> &nbsp;&nbsp;&nbsp;
                </Grid>
                 <Grid item xs={10}> */
        <TreeItem
            collapseIcon={<CheckBoxIcon/>}
            expandIcon={<CheckBoxOutlineBlankIcon/>}
            classes={{expanded: classes.expanded}}
            nodeId={nodeId}
            label={
                <Typography style={{fontSize: 12}}>
                    <InfoIconComponent docs={docs}/>
                    {label}
                </Typography>
            }
        >
            {tacticComponent}
        </TreeItem>
        /*}</Grid>
                </Grid>*/
    );
}

export function CreateTacticTextField({
                                          label,
                                          defaultValue,
                                          onBlurFunc,
                                          props,
                                      }) {
//    const turnIntoRef = useRef();
    //  turnIntoRef.current =
    //    defaultValue === undefined || defaultValue === null ? "" : defaultValue;

    return (
        <CreateTextField
            label={label}
            //      reference={turnIntoRef}
            defaultValue={defaultValue}
            onBlurFunc={onBlurFunc}
            props={props}
        />
    );
}

function CreateTextField({label, onBlurFunc, props, defaultValue}) {
    const [currentField, setField] = useState(defaultValue + "");
    useEffect(() => {
        setField(defaultValue + "");
    }, [defaultValue])
    return (
        <>
            <InputLabel style={{fontSize: "1rem"}}>
                <Typography style={{fontSize: 7}}>
                    <b>{label}:</b>
                </Typography>
            </InputLabel>
            <Input
                id={label}
                size="small"
                style={{height: 15, fontSize: 12, width: 60}}
                value={currentField}
                onChange={async (ev) => {
                    setField(ev.target.value);
                    //reference.current = ev.target.value;
                }}
                onBlur={(ev) => onBlurFunc(ev)}
                {...props}
            />
        </>
    );
}

export function qtyFieldAdornment(top) {
    let qtyAdornment =
        top.quantityBasis === "QUANTITY"
            ? top.instrument === "stock"
            ? "shares"
            : top.instrument === "option"
                ? "contracts"
                : ""
            : top.quantityBasis === "DOLLARS"
            ? "$"
            : "";
    return (
        <InputAdornment position="end">
            <Typography style={{fontSize: 8}}>{qtyAdornment}</Typography>
        </InputAdornment>
    );
}
